import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const pad = (n) => String(n).padStart(2, "0");

export const useElapsed = () => {
  const [s, setS] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setS((v) => v + 1), 1000);
    return () => clearInterval(t);
  }, []);
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
};

const Ticks = () => (
  <g>
    {Array.from({ length: 60 }).map((_, i) => (
      <line key={i} x1="100" y1={i % 5 ? 14 : 10} x2="100" y2="20" stroke="#0E0E10" strokeWidth={i % 5 ? 0.8 : 1.8}
        transform={`rotate(${i * 6} 100 100)`} opacity={i % 5 ? 0.45 : 1} />
    ))}
  </g>
);

export const Stopwatch = () => {
  const elapsed = useElapsed();
  return (
    <div className="relative aspect-square w-full" data-testid="hero-stopwatch">
      <svg viewBox="0 0 200 200" className="h-full w-full overflow-visible">
        <rect x="92" y="-6" width="16" height="10" rx="2" fill="#0E0E10" />
        <circle cx="100" cy="100" r="96" fill="#F1ECE2" stroke="#0E0E10" strokeWidth="2.5" />
        <Ticks />
        <motion.circle cx="100" cy="100" r="70" fill="none" stroke="#2234F5" strokeWidth="9" strokeLinecap="round"
          transform="rotate(-90 100 100)" initial={{ pathLength: 0 }} animate={{ pathLength: 5 / 12 }}
          transition={{ duration: 2.2, delay: 0.9, ease: [0.22, 1, 0.36, 1] }} />
        <motion.circle cx="100" cy="100" r="56" fill="none" stroke="#FF4D1A" strokeWidth="9" strokeLinecap="round"
          transform="rotate(-90 100 100)" initial={{ pathLength: 0 }} animate={{ pathLength: 1 / 12 }}
          transition={{ duration: 1.4, delay: 1.3, ease: [0.22, 1, 0.36, 1] }} />
        <g className="hand-sweep">
          <line x1="100" y1="100" x2="100" y2="24" stroke="#FF4D1A" strokeWidth="2" strokeLinecap="round" />
          <line x1="100" y1="100" x2="100" y2="114" stroke="#FF4D1A" strokeWidth="2" strokeLinecap="round" />
        </g>
        <circle cx="100" cy="100" r="4" fill="#0E0E10" />
      </svg>
      <div className="pointer-events-none absolute inset-x-0 bottom-[22%] text-center">
        <p className="font-mono-x text-[0.62rem] uppercase tracking-[0.2em] text-[#57534B]">since you arrived</p>
        <p className="font-mono-x text-lg font-bold tabular-nums sm:text-xl" data-testid="hero-elapsed">{elapsed}</p>
      </div>
    </div>
  );
};
